'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.itemActiveListItem = exports.itemIsActive = exports.itemInFavs = exports.findItemInFavs = exports.userHasFavorites = exports.favItems = exports.favListElements = exports.createdActions = exports.favListFull = exports.favsListSelector = exports.userNeedsCollection = exports.userHasCollections = exports.userCollectionsItem = exports.userCollections = exports.itemCollectionsHash = exports.getListCollectionId = exports.itemCollections = exports.listItemsByItem = exports.activeListItems = exports.activeListItemFull = exports.activeListItem = exports.listItemSelector = exports.collectionListSelector = exports.getActiveListItem = exports.getActiveCollection = exports.getActiveItem = exports.getCollectionState = exports.propsItemKey = exports.getPropsItem = exports.fpGetRef = undefined;

var _pickBy2 = require('lodash/fp/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _omitBy2 = require('lodash/fp/omitBy');

var _omitBy3 = _interopRequireDefault(_omitBy2);

var _map2 = require('lodash/fp/map');

var _map3 = _interopRequireDefault(_map2);

var _keyBy2 = require('lodash/fp/keyBy');

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _groupBy2 = require('lodash/fp/groupBy');

var _groupBy3 = _interopRequireDefault(_groupBy2);

var _find2 = require('lodash/fp/find');

var _find3 = _interopRequireDefault(_find2);

var _spread2 = require('lodash/spread');

var _spread3 = _interopRequireDefault(_spread2);

var _rearg2 = require('lodash/rearg');

var _rearg3 = _interopRequireDefault(_rearg2);

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _over2 = require('lodash/over');

var _over3 = _interopRequireDefault(_over2);

var _negate2 = require('lodash/negate');

var _negate3 = _interopRequireDefault(_negate2);

var _mapValues2 = require('lodash/mapValues');

var _mapValues3 = _interopRequireDefault(_mapValues2);

var _has2 = require('lodash/has');

var _has3 = _interopRequireDefault(_has2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _identity2 = require('lodash/identity');

var _identity3 = _interopRequireDefault(_identity2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

exports.findItemInListItems = findItemInListItems;

var _reselect = require('reselect');

var _capeSelect = require('cape-select');

var _capeLodash = require('cape-lodash');

var _capeReduxAuth = require('cape-redux-auth');

var _reduxGraph = require('redux-graph');

var _helpers = require('./helpers');

var _lang = require('./lang');

var _const = require('./const');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fpGetRef = exports.fpGetRef = (0, _curry3.default)((0, _rearg3.default)(_reduxGraph.getRef, [1, 0]), 2);
// import { getDataFeed, getWebApp } from '../select'
// import { itemsFilled } from '../select/items'

var getPropsItem = exports.getPropsItem = (0, _capeSelect.select)(_capeSelect.getProps, 'item');
var propsItemKey = exports.propsItemKey = (0, _capeSelect.simpleSelector)(getPropsItem, _reduxGraph.getKey);

// Redux Collection State
var getCollectionState = exports.getCollectionState = (0, _property3.default)('collection');
var getActiveItem = exports.getActiveItem = (0, _capeSelect.select)(getCollectionState, 'item');
var getActiveCollection = exports.getActiveCollection = (0, _capeSelect.select)(getCollectionState, 'collection');
var getActiveListItem = exports.getActiveListItem = (0, _capeSelect.select)(getCollectionState, 'listItem');

// COLLECTIONS

// Select all CollectionList entities from the database.
var collectionListSelector = exports.collectionListSelector = (0, _reduxGraph.entityTypeSelector)(_const.COLLECTION_TYPE);
// export const collections = rebuildEntitiesSelector(collectionListSelector)

// LIST ITEM

// Select all ListItem entities.
var listItemSelector = exports.listItemSelector = (0, _reduxGraph.entityTypeSelector)(_const.LIST_ITEM);
// Gets currently active ListItem.
var activeListItem = exports.activeListItem = (0, _reselect.createSelector)(listItemSelector, _helpers.findActionCreated);
// export const activeListItemList = flow(
//   activeListItem, property('rangeIncludes')
// )
var activeListItemFull = exports.activeListItemFull = (0, _reduxGraph.allChildrenSelector)(activeListItem);

var activeListItems = exports.activeListItems = (0, _reselect.createSelector)(listItemSelector, (0, _pickBy3.default)(_lang.isValidListItem));
var listItemsByItem = exports.listItemsByItem = (0, _reselect.createSelector)(activeListItems, (0, _groupBy3.default)(function (listItem) {
  return (0, _reduxGraph.getKey)((0, _lang.getItemRef)(listItem));
}));
var itemCollections = exports.itemCollections = (0, _capeSelect.getSelect)(listItemsByItem, propsItemKey);
var getListCollectionId = exports.getListCollectionId = (0, _flow3.default)((0, _property3.default)(['rangeIncludes', _const.PREDICATE]), (0, _find3.default)(_identity3.default), (0, _property3.default)('id'));
var itemCollectionsHash = exports.itemCollectionsHash = (0, _reselect.createSelector)(itemCollections, (0, _keyBy3.default)(getListCollectionId));

// USER COLLECTIONS - No props needed.
// Find user collections. Returns empty object when nothing found.
var userCollections = exports.userCollections = (0, _reselect.createSelector)(_capeReduxAuth.selectUser, collectionListSelector, (0, _reduxGraph.predicateFilter)('creator'));
// Add field to collections if the item is in it.
var userCollectionsItem = exports.userCollectionsItem = (0, _reselect.createSelector)(userCollections, itemCollectionsHash, function (collections, itemHash) {
  return (0, _mapValues3.default)(collections, function (collection, id) {
    return (0, _capeLodash.set)('itemListId', collection, (0, _has3.default)(itemHash, id) && itemHash[id].id || null);
  });
});

var userHasCollections = exports.userHasCollections = (0, _capeSelect.boolSelector)(userCollections);
var userNeedsCollection = exports.userNeedsCollection = (0, _negate3.default)(userHasCollections);
// Find (first) user favs project from list entities.
var favsListSelector = exports.favsListSelector = (0, _reselect.createSelector)(userCollections, (0, _find3.default)(_lang.isFavList));
// CollectionList id of user favs.
// export const favListId = select(favsListSelector, 'id')
// ListItems attached to the user favs collection via PREDICATE field/triple predicate.
// Returns object keyed with listItem id.
var favListFull = exports.favListFull = (0, _reduxGraph.allChildrenSelector)(favsListSelector);
var createdActions = exports.createdActions = (0, _flow3.default)((0, _property3.default)(_const.PREDICATE), (0, _omitBy3.default)(_lang.isActionEnded));
var favListElements = exports.favListElements = (0, _reselect.createSelector)(favListFull, createdActions);
var favItems = exports.favItems = (0, _reselect.createSelector)(favListElements, (0, _map3.default)('item'));
function findItemInListItems(items, item) {
  return (0, _find3.default)({ item: (0, _pick3.default)(item, 'id', 'type') })(items);
}
var userHasFavorites = exports.userHasFavorites = (0, _capeSelect.boolSelector)(favListElements);
// Items is expected to come props style findItemInFavs(state, { item })
var findItemInFavs = exports.findItemInFavs = (0, _reselect.createSelector)(favListElements, getPropsItem, findItemInListItems);
// Used by React selector where item is in props arg.
var itemInFavs = exports.itemInFavs = (0, _capeSelect.boolSelector)(findItemInFavs);

// Is the component item the same as the one used in the most recent `open` action?
var itemIsActive = exports.itemIsActive = (0, _flow3.default)((0, _over3.default)(getPropsItem, getActiveItem), (0, _spread3.default)(_reduxGraph.entityMatch));
// Is the component item the same as the one used to create the most recent ListItem?
var itemActiveListItem = exports.itemActiveListItem = function itemActiveListItem(state, _ref) {
  var item = _ref.item;

  var createdListItem = activeListItemFull(state);
  // console.log(item, activeListItem)
  if ((0, _reduxGraph.entityMatch)(item, createdListItem.item)) return createdListItem;
  return null;
};
// export const itemListItems
// ITEM CONTAINER
// Used in the ItemFav container.
var mapStateToProps = exports.mapStateToProps = (0, _reselect.createStructuredSelector)({
  itemActiveListItem: itemActiveListItem, // Single listItem entity.
  collections: userCollectionsItem,
  // inCollections: itemInCollections,
  itemIsActive: itemIsActive
});


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/lib/select.js
// module id = 233
// module chunks = 0